import { Button, Box, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';

interface CellOfferHeadlineProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children: React.ReactNode;
}

function formatPublishedDate(isoDate: string | null | undefined): string {
  if (!isoDate) return 'Published';
  try {
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return 'Published';
    return `Published on ${d.toLocaleDateString(undefined, {
      dateStyle: 'medium',
    })}`;
  } catch {
    return 'Published';
  }
}

const CellOfferHeadline = ({ params, onClick, children }: CellOfferHeadlineProps) => {
  const isPublished = String(params?.row?.status ?? '').toUpperCase() === 'PUBLISHED';
  const publishedAt =
    params?.row?.published_at ?? params?.row?.published_date ?? params?.row?.publishedAt;
  const tooltipTitle = isPublished
    ? formatPublishedDate(publishedAt)
    : '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        width: 'fit-content',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <Button
        variant="text"
        size="small"
        tabIndex={params.hasFocus ? 0 : -1}
        sx={{
          color: 'text.primary',
          textDecoration: 'underline',
          textTransform: 'none',
          fontSize: '14px',
          justifyContent: 'flex-start',
          padding: 0,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick(params);
        }}
      >
        {children}
      </Button>
      {isPublished && (
        <Tooltip title={tooltipTitle}>
          <CheckCircleIcon
            sx={{
              fontSize: 18,
              color: 'success.main',
              flexShrink: 0,
            }}
            aria-label={tooltipTitle}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default CellOfferHeadline;
